// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameSecond as fn } from "../isSameSecond.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameSecond = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isSameSecond;
